"use client";

import { ThemeProvider } from "next-themes";
import { ThirdwebProvider } from "thirdweb/react";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY!}
      scriptProps={{ async: true, defer: true, appendTo: "head" }}
      language="en"
    >
      <ThemeProvider attribute="class" defaultTheme="light" enableSystem>
        <ThirdwebProvider>{children}</ThirdwebProvider>
      </ThemeProvider>
    </GoogleReCaptchaProvider>
  );
}
